import React from 'react';

const services = [
  { icon: '🏠', title: 'Commercial & Domestic', desc: 'Reliable service for homes, units and businesses.' },
  { icon: '🌱', title: 'Regular Mowing', desc: 'Sharp cuts, clean edges, consistent schedules.' },
  { icon: '✂️', title: 'Edging & Trimming', desc: 'Crisp edges to paths, driveways and garden beds.' },
  { icon: '🌿', title: 'Weeding & Weed Control', desc: 'Hand weeding and safe treatments to prevent regrowth.' },
  { icon: '🌳', title: 'Hedging & Pruning', desc: 'Neat hedges and healthier plants, shaped to perfection.' },
  { icon: '🪚', title: 'Small Tree Lopping', desc: 'Light tree work and tidy removals.' },
  { icon: '🔧', title: 'Lawn Repair', desc: 'Top-dressing, re-seeding and patch fixes.' },
  { icon: '🧹', title: 'Green Waste Disposal', desc: 'All clippings and green waste taken away.' },
  { icon: '🗑️', title: 'Rubbish Removal', desc: 'Yard clean-ups and general waste removal.' },
  { icon: '🏠', title: 'Gutter Cleaning (Single Story)', desc: 'Clear gutters and downpipes to prevent blockages.' },
  { icon: '💧', title: 'Pressure Cleaning', desc: 'Driveways & pathways cleaned and refreshed.' },
];

const ServicesGrid = ({ withHeading = true }) => (
  <section className="section services-section" id="services">
    <div className="container">
      {withHeading && <>
        <h2 className="section-title">Our Professional Services</h2>
        <p className="section-subtitle">No job too big, no garden too small – see how we can help transform your outdoor space!</p>
      </>}
      <div className="services-grid">
        {services.map((s, idx) => (
          <div className="service-card" key={idx}>
            <div className="service-icon">{s.icon}</div>
            <h3 className="service-title">{s.title}</h3>
            <p className="service-desc">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesGrid;


